enum FieldViewType {
  TICKET_TRANSFER = "TICKET_TRANSFER",
  TICKET_ASSIGNMENT = "TICKET_ASSIGNMENT"
}

export default FieldViewType;
